import _defineProperty from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/opt/buildhome/repo/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { complex, color } from 'style-value-types';
import { mix } from './mix.mjs';
import { mixColor } from './mix-color.mjs';
import { pipe } from './pipe.mjs';
import { warning } from 'hey-listen';
function getMixer(origin, target) {
  if (typeof origin === "number") {
    return function (v) {
      return mix(origin, target, v);
    };
  } else if (color.test(origin)) {
    return mixColor(origin, target);
  } else {
    return mixComplex(origin, target);
  }
}
var mixArray = function mixArray(from, to) {
  var output = _toConsumableArray(from);
  var numValues = output.length;
  var blendValue = from.map(function (fromThis, i) {
    return getMixer(fromThis, to[i]);
  });
  return function (v) {
    for (var i = 0; i < numValues; i++) {
      output[i] = blendValue[i](v);
    }
    return output;
  };
};
var mixObject = function mixObject(origin, target) {
  var output = _objectSpread(_objectSpread({}, origin), target);
  var blendValue = {};
  for (var key in output) {
    if (origin[key] !== undefined && target[key] !== undefined) {
      blendValue[key] = getMixer(origin[key], target[key]);
    }
  }
  return function (v) {
    for (var _key in blendValue) {
      output[_key] = blendValue[_key](v);
    }
    return output;
  };
};
/**
 * TODO: Combine with function within complex when style-value-types moved inside Framer Motion
 */
function analyse(value) {
  var parsed = complex.parse(value);
  var numValues = parsed.length;
  var numNumbers = 0;
  var numColors = 0;
  for (var i = 0; i < numValues; i++) {
    // Parsed complex values return with colors first, so if we've seen any number
    // we're already past that part of the array and don't need to continue running typeof
    if (numNumbers || typeof parsed[i] === "number") {
      numNumbers++;
    } else {
      numColors++;
    }
  }
  return {
    parsed: parsed,
    numNumbers: numNumbers,
    numColors: numColors
  };
}
var mixComplex = function mixComplex(origin, target) {
  var template = complex.createTransformer(target);
  var originStats = analyse(origin);
  var targetStats = analyse(target);
  var canInterpolate = originStats.numColors === targetStats.numColors && originStats.numNumbers >= targetStats.numNumbers;
  if (canInterpolate) {
    return pipe(mixArray(originStats.parsed, targetStats.parsed), template);
  } else {
    warning(true, "Complex values '".concat(origin, "' and '").concat(target, "' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition."));
    return function (p) {
      return "".concat(p > 0 ? target : origin);
    };
  }
};
export { mixArray, mixComplex, mixObject };